import type { CodesDetail } from '@/api/model/basicTypes'
import type { CodesDetailItemsModel } from '@/api/model/codesModel'
import type { Getter } from 'vuex'
import type { State } from './state'
import type {
  FileItem,
  PrepareUploadFileItem,
  UploadFileItem,
  UploadFileList,
} from '@/api/product/model/documentModel'

import { useStorage } from '@/hooks/core/useStorage'
import { formatDate } from '@/utils'

const { loadCodesInformation } = useStorage()

const getters: { [type: string]: Getter<State, any> } = {
  documentName: (state: State): string => {
    const codes = loadCodesInformation()?.find(
      (item: CodesDetail): boolean => item.management_code === 'DOCUMENT_TYPE'
    )

    const target = codes?.item.find(
      (item: CodesDetailItemsModel): boolean =>
        item.value === state.originalDocumentItem.document_type
    )

    return target?.name ?? ''
  },

  documentItemEdited: (state: State): boolean => {
    // OCR読取結果項目の変更は検知しないよう修正（入力された内容は保存されませんが、よろしいですか？の表示に使用）
    //return (
      //JSON.stringify(state.originalDocumentItem) !==
      //JSON.stringify(state.compareDocumentItem)
    //)

    // ドキュメント情報、ファイル一覧の編集判定材料整理
    function removeReadCategoryName(fileItem:any) {
      const { read_category_name, ...rest } = fileItem;
      return rest;
    }
    
    function removeReadCategoryNameFromDocument(documentItem:any) {
      return {
        ...documentItem,
        file_list: documentItem.file_list.map(removeReadCategoryName)
      };
    }
    
    const originalWithoutReadCategoryName = removeReadCategoryNameFromDocument(state.originalDocumentItem);
    const compareWithoutReadCategoryName = removeReadCategoryNameFromDocument(state.compareDocumentItem);

    return (
      // ドキュメント情報、ファイル一覧の編集判定
      JSON.stringify(originalWithoutReadCategoryName) !== JSON.stringify(compareWithoutReadCategoryName)
      // OCR読取結果の編集判定
      || JSON.stringify(state.originalOcrDataItem) !== JSON.stringify(state.compareOcrDataItem)
    )
  },

  uploadFileList: (state: State): UploadFileList => {
    const { loadUserLoginInformation } = useStorage()
    const loginInformation = loadUserLoginInformation()
    const corporateID = loginInformation?.corporate_id ?? -1

    // 削除済みファイル
    const deletedFileFilter = (item: FileItem): boolean => {
      const file = state.originalDocumentItem.file_list.find(
        (file: FileItem) => file?.file_id === item.file_id
      )

      return file ? false : true
    }

    const deletedList = state.compareDocumentItem.file_list.filter(deletedFileFilter)

    const _deletedList = deletedList.map<UploadFileItem>((item: FileItem) => ({
      file_id: item.file_id,
      upload_corporate_id: corporateID,
      revision_date: item.revision_date,
      file_name: item.file_name,
      file_path: item.file_path,
      file_size: item.file_size,
      delete_flag: '1',
      public_flag: item.public_flag,
      file_info_only_upload_flag: '0',
    }))

    // 新規登録ファイル
    const newFileList = state.originalDocumentItem.file_list.filter((item: FileItem) =>
      state.prepareUploadFiles
        .map<number>((file: PrepareUploadFileItem) => file.fileID)
        .includes(item.file_id)
    )

    const _newFileList = newFileList.map<UploadFileItem>((item: FileItem) => ({
      file_id: item.file_id,
      upload_corporate_id: corporateID,
      revision_date: formatDate(item.revision_date),
      file_name: item.file_name,
      file_path: item.file_path,
      file_size: item.file_size,
      delete_flag: '0',
      public_flag: item.public_flag,
      file_info_only_upload_flag: '0',
    }))

    // 更新ファイル（SDSDirectへの公開フラグ更新）

    const updateFileList = state.originalDocumentItem.file_list.filter((item: FileItem) =>
      state.compareDocumentItem.file_list
        .some((file: FileItem) => file.file_id === item.file_id && file.public_flag !== item.public_flag)
    )

    const _updateFileList = updateFileList.map<UploadFileItem>((item: FileItem) => ({
      file_id: item.file_id,
      upload_corporate_id: corporateID,
      revision_date: formatDate(item.revision_date),
      file_name: item.file_name,
      file_path: item.file_path,
      file_size: item.file_size,
      delete_flag: '0',
      public_flag: item.public_flag,
      file_info_only_upload_flag: '1',
    }))

    return [..._deletedList, ..._newFileList, ..._updateFileList]
  },
}

export default getters
